import { Report } from '../../dtos/Report'

export default interface ReportsState {
    reports: Report[]
    selectedReport: Report
}

export const defaultReportsState = {
    reports: [] as Report[],
    selectedReport: null
}
